class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

/* PAPAPATTES 29/09 : delai (ms) avant l'ouverture au survol du menu
   header (items de premier niveau avec sous-menu, ex. CHIEN/CHAT),
   desktop uniquement (>= 990px). Mis a 0 (retour Sid 29/09, v7) :
   ouverture immediate au survol, plus de delai. */
var PP_HEADER_MENU_HOVER_DELAY_MS = 0;

/* PAPAPATTES 29/09 (v2, retour Sid — correctif clignotement) : delai
   avant la FERMETURE au survol, annule si la souris revient dans le
   meme menu avant la fin du delai.
   Cause du bug : le panneau (mega-panel) est bien plus large que son
   declencheur (ex. "Chien" ~9rem de large, panneau ~70rem). En
   descendant la souris en diagonale vers une tuile ou le visuel a
   droite du panneau, le curseur frole parfois un espace vide ou le
   lien voisin (CHAT, OISEAU...) — l'ancienne fermeture INSTANTANEE
   (sans delai, contrairement a l'ouverture qui en a un) fermait alors
   le panneau une fraction de seconde avant qu'il ne se rouvre :
   clignotement / instabilite. Le delai de fermeture absorbe ces
   traversees breves. */
var PP_HEADER_MENU_CLOSE_DELAY_MS = 200;

/* PAPAPATTES 11/10 : delai avant de BASCULER vers un autre animal quand
   un menu est deja ouvert (ex. CHIEN ouvert, le curseur frole CHAT en
   route vers une rubrique : on ne bascule que si la souris y reste). */
var PP_HEADER_MENU_SWITCH_DELAY_MS = 200;

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimer = null;
    this.closeTimer = null;

    /* PAPAPATTES 29/09 :
       - survol (desktop) : ouvre le sous-menu apres
         PP_HEADER_MENU_HOVER_DELAY_MS.
       - clic sur le libelle (ex. "Chien") : navigue directement vers
         la page de la collection (data-url pose en Liquid).
       - clic sur le chevron (.pp-menu-caret-toggle) : bascule
         ouvrir/fermer sans naviguer (fallback clavier / tactile). */
    this.summaryEl = this.mainDetailsToggle.querySelector('summary');
    this.caretEl = this.summaryEl ? this.summaryEl.querySelector('.pp-menu-caret-toggle') : null;
    this.menuUrl = this.dataset.url;
    /* PAPAPATTES 15/10 : reglage « Ouvrir les sous-menus au survol »
       (settings.pp_menu_survol). Vrai = survol, faux = clic. */
    this.openOnHover = this.dataset.hover !== 'false';

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    if (this.summaryEl) {
      this.summaryEl.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  /* PAPAPATTES 15/10 : en mode clic, le survol n'est actif qu'une fois un
     menu ouvert au clic (par chargement de page, non persiste). */
  hoverActive() {
    return this.openOnHover || HeaderMenu.hoverUnlocked;
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  onMouseEnter() {
    if (!this.hoverActive() || !this.isDesktop()) return;
    clearTimeout(this.closeTimer);
    clearTimeout(this.hoverTimer);
    const otherOpen = Array.from(document.querySelectorAll('header-menu')).some(
      (menu) => menu !== this && menu.mainDetailsToggle && menu.mainDetailsToggle.hasAttribute('open')
    );
    this.hoverTimer = setTimeout(() => {
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
      }
    }, otherOpen ? PP_HEADER_MENU_SWITCH_DELAY_MS : PP_HEADER_MENU_HOVER_DELAY_MS);
  }

  onMouseLeave() {
    clearTimeout(this.hoverTimer);
    if (!this.isDesktop()) return;
    clearTimeout(this.closeTimer);
    // Mode clic : fermeture immediate des que la souris quitte le menu, sans delai.
    if (!this.hoverActive()) {
      if (this.mainDetailsToggle.hasAttribute('open')) this.close();
      return;
    }
    this.closeTimer = setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open')) this.close();
    }, PP_HEADER_MENU_CLOSE_DELAY_MS);
  }

  close() {
    clearTimeout(this.hoverTimer);
    clearTimeout(this.closeTimer);
    super.close();
  }

  onSummaryClick(event) {
    // Mode clic : le libelle bascule ouvrir/fermer (comportement natif de <details>).
    if (!this.openOnHover) return;
    if (this.caretEl && (event.target === this.caretEl || this.caretEl.contains(event.target))) {
      // Clic sur le chevron : bascule normale du sous-menu, pas de navigation.
      return;
    }
    if (this.menuUrl) {
      event.preventDefault();
      window.location.href = this.menuUrl;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // PAPAPATTES 11/09 : quand on ouvre un menu de premier niveau
    // (ex. CHIEN), on ferme tous les autres deja ouverts (ex. CHAT).
    // Les items du menu restent visibles dans la barre, seul leur
    // sous-menu deroulant se referme.
    if (this.mainDetailsToggle.hasAttribute('open')) {
      // Mode clic : la 1re ouverture (forcement au clic) debloque le survol.
      if (!this.openOnHover) HeaderMenu.hoverUnlocked = true;
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this && menu.mainDetailsToggle && menu.mainDetailsToggle.hasAttribute('open')) {
          menu.close();
        }
      });
    }

    // PAPAPATTES 29/09 : recalcule a CHAQUE ouverture (plus seulement la
    // premiere fois) — cette valeur sert aussi de position pour
    // .pp-menu-overlay (cf. pp-menu-header.css section 11), qui doit
    // rester exacte meme si la hauteur du header change (sticky header
    // reduit, etc.).
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

HeaderMenu.hoverUnlocked = false;

customElements.define('header-menu', HeaderMenu);

/* PAPAPATTES 29/09 : clic sur le calque sombre (.pp-menu-overlay, cf.
   sections/header.liquid) = ferme le menu ouvert. La visibilite de
   l'overlay est geree en CSS pur (:has), ce script ne gere que la
   fermeture au clic. */
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.querySelector('.pp-menu-overlay');
  if (!overlay) return;
  overlay.addEventListener('click', () => {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.mainDetailsToggle && menu.mainDetailsToggle.hasAttribute('open')) {
        menu.close();
      }
    });
  });
});
